angular.module('cvsApp').service('getQuestionsService',['cvsAppData', 'pznQuestionsModel','configManager','networkService','itemCartModel', function (CAD,PQM,CM,NS,ICM) {

	function getQuestionsService (){
		var self = this;
		
		
        this.getpznQuestions = function(callBackSuccess){
           
            var tokenID = CAD.getTokenId();
            var url = CM.getAGPAPIUrl('AGP_GET_QUESTIONS');
            if(url === "URL_ERROR"){

            }else{
                var request = {url:url,
                    header:{"Content-Type": "application/json",
					"Accept":"application/json"},
                    data:getRequestBody(),
                    onSuccess:callBackSuccess
                }

                cvsUtility.commonServiceCode(url,"getQuestions",self,request,callBackSuccess,NS);
            }
        };
        this.setResponse = function(data){
			/*var d = t.replace(/"value"/g, '"y"');*/
			String.prototype.replaceAll = function(search, replacement) {
				var target = this;
				return target.split(search).join(replacement);
			};
			var stringified = JSON.stringify(data);
			stringified = stringified.replaceAll('"clinicalQuestion"', '"clinicalQuestions"');
			stringified = stringified.replaceAll('"answerOption"', '"answerOptions"');
			stringified = stringified.replaceAll('"subQuestion"', '"subQuestions"');
			var jsonObject = JSON.parse(stringified);
			PQM.setResponse(jsonObject);
		}	

		this.getResponse = function(){				
			return PQM.getResponse();		
		}
        var getRequestBody = function(){
            var drugArray = [];
            if(!CAD.getDrugDataList()){
                var dList = ICM.getCartItems();
                for(var i =0; i< dList.length; i++){
                    var obj = {"sourceSystem": dList[i].prescriptionSystemName,
                    "rxNumber": dList[i].rxNumber,
                        "rxNumberEnc": dList[i].rxNumberEnc,
                        "rxNumberHash": dList[i].rxNumberHash,
                        "drugName": dList[i].drugName,
                        "drugNameEnc": dList[i].drugNameEnc,
                        "drugNdc": dList[i].dispensedDrugNDC,
                        "firstFillIndicator": dList[i].firstFillIndicator,
                        "ancillaryProductInd": dList[i].ancillaryProductInd
                    }
                    if (dList[i].suppliesGrouped) {
                        var groupSupply = dList[i].suppliesGrouped;
                        var supplyObj = [];
                        for (var j = 0; j < groupSupply.length; j++) {
                            (function (j) {
                                var groupedObj = {
                                    "sourceSystem": groupSupply[j].prescriptionSystemName,
                                    "rxNumber": groupSupply[j].rxNumber,
                                    "rxNumberEnc": groupSupply[j].rxNumberEnc,
                                    "rxNumberHash": groupSupply[j].rxNumberHash,
                                    "drugName": groupSupply[j].drugName,
                                    "drugNameEnc": groupSupply[j].drugNameEnc,
                                    "drugNdc": groupSupply[j].dispensedDrugNDC,
                                    "firstFillIndicator": groupSupply[j].firstFillIndicator,
                                    "ancillaryProductInd": groupSupply[j].ancillaryProductInd
                                }
                                drugArray.push(groupedObj);

                            })(j);
                        }
                    }

                    drugArray.push(obj);
                }
            }else{
                drugArray = CAD.getDrugDataList();
            }

            var requestJson = {"getQuestionsRequest": {
                "header": {
                    "serviceContext": {
                        "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                        "lineOfBusiness": "Specialty",
                        "channelName": cvsUtility.queryMap.channel,
                        "responseFormat": "JSON",
                        "type": "SPLSBMS",
                        "bkAppName": "orderService",
                        "tokenID": CAD.getTokenId(),
                        "tokenType": CM.getAGPTokenType(CAD.getTokenType())
                    },
                    "securityContext": {
                        "apiKey": CAD.getApiKey(),
                        "securityType": "apiKey"
                    }
                },
                "details": {
                
                "rxInfos": drugArray
            }
            }
            };

            return requestJson;

        };
	}


	return new getQuestionsService();
}]);
